import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "left" }
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("fieldset", null, [
      _cache[15] || (_cache[15] = _createElementVNode("legend", null, "おまけ", -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("article", null, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.configurationInputRea['全武器解放']) = $event)),
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:configuration-input', _ctx.configurationInputRea)))
            }, null, 544), [
              [_vModelCheckbox, _ctx.configurationInputRea['全武器解放']]
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("span", null, "全ての武器が選択可能になる", -1))
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "notice" }, " ※正規の武器タイプ以外の武器を選択した場合、構成保存できなくなります。 ", -1))
        ]),
        _createElementVNode("article", null, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.configurationInputRea['聖遺物詳細サブ効果オンリー']) = $event)),
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:configuration-input', _ctx.configurationInputRea)))
            }, null, 544), [
              [_vModelCheckbox, _ctx.configurationInputRea['聖遺物詳細サブ効果オンリー']]
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("span", null, "聖遺物詳細の表示値をサブ効果のみの合計にする", -1))
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "notice" }, [
            _createTextVNode(" 聖遺物詳細の表示値からメイン効果分が除外されます。"),
            _createElementVNode("br")
          ], -1))
        ]),
        _createElementVNode("article", null, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.configurationInputRea['聖遺物サブ効果計算停止']) = $event)),
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:configuration-input', _ctx.configurationInputRea)))
            }, null, 544), [
              [_vModelCheckbox, _ctx.configurationInputRea['聖遺物サブ効果計算停止']]
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("span", null, "聖遺物サブ効果の自動計算を止める", -1))
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "notice" }, [
            _createTextVNode(" 聖遺物サブ効果が自動計算されなくなります。"),
            _createElementVNode("br"),
            _createTextVNode(" 手動で入力して下さい。 ")
          ], -1))
        ]),
        _createElementVNode("article", null, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.initializeArtifactStatsSubClickableRef) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.initializeArtifactStatsSubClickableRef]
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("span", null, "聖遺物サブ効果0初期化", -1))
          ]),
          _createElementVNode("button", {
            type: "button",
            disabled: !_ctx.initializeArtifactStatsSubClickableRef,
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.initializeArtifactStatsSub && _ctx.initializeArtifactStatsSub(...args)))
          }, _toDisplayString(_ctx.displayName('実行')), 9, _hoisted_2)
        ])
      ])
    ]),
    _createElementVNode("div", null, _toDisplayString(_ctx.screen.width) + " , " + _toDisplayString(_ctx.screen.height), 1)
  ], 64))
}